/**

Coded by www.techhighway.ca

*/

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDDialog from "components/MDDialog";

// Material Dashboard 2 React example components
import DashboardLayout from "components/LayoutContainers/DashboardLayout";

import DataTable from "components/Tables/DataTable";

// Data
import parameterData from "layouts/manage-parameters/data";

function Parameters() {
  const {
    columns,
    rows,
    open,
    handleClickOpen,
    handleClose,
    deleteParameter,
    selectedId,
    totalData,
    page,
    pageSize,
    getData,
    sortColumn,
    sortColumnValue,
    searchValue,
    pagePermission,
    isData,
  } = parameterData();

  return (
    <>
      <DashboardLayout breadcrumbsTitle="Manage Parameters">
        <MDBox>
          <DataTable
            entriesPerPage={{
              defaultValue: pageSize,
            }}
            canSearch
            showTotalEntries
            table={{ columns, rows }}
            isSorted
            totalData={totalData}
            initialPageIndex={page - 1}
            getData={getData}
            pageCount={Math.ceil(totalData / pageSize)}
            sortCol={sortColumn}
            sortColValue={sortColumnValue}
            searchVal={searchValue}
            noEndBorder={false}
            isData={isData}
          />
        </MDBox>

        {/* Action buttons for listing pages should go inside this MDBox */}
        <MDBox position="absolute" right="10px" mt={-4.5}>
          {pagePermission.new ? (
            <MDButton
              component={Link}
              color="info"
              coloredShadow="info"
              variant="gradient"
              to="/manage-parameters/add"
              title="Add New Parameter"
              iconOnly
              circular
            >
              <Icon fontSize="medium" sx={{ fontWeight: "bold", fontSize: "16px" }}>
                add
              </Icon>
            </MDButton>
          ) : (
            ""
          )}
        </MDBox>
      </DashboardLayout>

      <MDDialog
        open={open}
        onClose={handleClose}
        successAction={() => deleteParameter(selectedId)}
        dialogTitle="Are you Sure?"
        cancleButton="No, Please!"
        successButton="Yes, Delete it!"
        cancleButtonColor="light"
        successButtonColor="info"
        icon={
          <Icon sx={{ width: "100%", marginTop: "25px" }} fontSize="large" color="primary">
            error
          </Icon>
        }
      >
        <p>You will not be able to recover the deleted record!</p>
      </MDDialog>
    </>
  );
}

export default Parameters;
